import React from 'react';
import { Radio, FormControlLabel, RadioGroup, Typography, Box } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { stringEnum } from 'common/utils/objects';
import { useTranslation } from 'services/localization';
import { NotificationRecipient } from 'common/types';

interface Props {
	merchantEmail?: string;
	storeEmail?: string;
	value: NotificationRecipient;
	onChange: (recipient: NotificationRecipient) => void;
}

const NotificationRecipients = stringEnum<NotificationRecipient>(['merchant', 'store']);

const RecipientSelection = (props: Props) => {
	const { value, onChange, merchantEmail, storeEmail } = props;
	const { t } = useTranslation();
	const classes = useStyles();

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		onChange(e.target.value as NotificationRecipient);
	};

	return (
		<>
			<Box mb={2}>
				<Typography variant="h6" component="div">
					{t('account.notifications.recipient', 'Recipient')}
				</Typography>
			</Box>
			<RadioGroup aria-label="scope" name="scope" value={value} onChange={handleChange}>
				<FormControlLabel
					value={NotificationRecipients.merchant}
					control={<Radio color="primary" />}
					label={
						<Typography variant="body2" className={classes.lightFont}>
							{t('account.notifications.useAccountEmail', 'Account email')}{' '}
							{!!merchantEmail ? `(${merchantEmail})` : ''}
						</Typography>
					}
				/>
				<Box mt={1} />
				<FormControlLabel
					value={NotificationRecipients.store}
					control={<Radio color="primary" />}
					label={
						<Typography variant="body2" className={classes.lightFont}>
							{t('account.notifications.useStoreEmail', 'Store email')}{' '}
							{!!storeEmail ? `(${storeEmail})` : ''}
						</Typography>
					}
				/>
			</RadioGroup>
		</>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		lightFont: {
			fontWeight: 400,
		},
	}),
);

export default RecipientSelection;
